import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';

import Layout from '../../components/Layout';
import BoxAgents from '../../components/BoxAgents';

class Agents extends Component {
    constructor(props) {
        super(props);
        this.state = {
            answered: 0,
            slQueuesValue: [],
            slQueuesOptions: [],
            filter: [],
        }

        this.onChangeQueueSelect = this.onChangeQueueSelect.bind(this);
    }

    async componentDidMount() {
    
        let queues = this.props.auth.queuesAvailable.map( q => ({ value: q.extension, label: `[${q.extension}] ${q.name}` })) ;
        let filter = this.props.auth.queuesAvailable.map( q => q.extension ) ;
        this.setState({
            slQueuesValue: queues,
            slQueuesOptions: queues,
            filter,
        })
        
    }

    onChangeQueueSelect(value, event) {
        let filter = value ? value.map( q => q.value ) : [];

        // console.log(filterQueues);
        this.setState({ 
            slQueuesValue: value,
            filter
        });
    }

    render() {

        return (
            <Layout>
                <section className="content-header">
                    <h1>
                        Agente(s)
                    </h1>
                    <ol className="breadcrumb">
                        <li><a href="#"  onClick={() => {}}><i className="fa fa-dashboard"></i> Home</a></li>
                        <li >Supervisor</li>
                        <li className="active">Agente(s)</li>
                    </ol>
                </section>

                <section className="content">
                    <div className="row">

                        <div className="col-md-12">
                            <div className="box">
                                <div className="box-body">
                                    <form >
                                        <div className="col-sm-10 offset-md-1">
                                            <label htmlFor="inputPassword3" className="col-sm-2 control-label">Filtro filas</label>

                                            <Select
                                                value={this.state.slQueuesValue}  
                                                isMulti
                                                options={this.state.slQueuesOptions}
                                                isClearable={true}
                                                onChange={this.onChangeQueueSelect}
                                            />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <BoxAgents queuesListener={this.state.filter}/>
                        </div>
                    </div>
                </section>
            </Layout>
        );
    }
}

const mapStateToProps = state => {
    return ({
        auth: state.AutenticacaoReducer,
    })
}
  
  
export default connect(mapStateToProps, null)(Agents);
